import ReservedList from "layouts/reservedList";

// @mui icons
import Icon from "@mui/material/Icon";
import Chat from "layouts/chat";
import Insurance from "layouts/insurance";
import ReservationStatus from "layouts/reservationStatus";
import Admission from "./layouts/admission";
import Dashboard from "./layouts/dashboard/Dashboard";
import FillTime from './layouts/fillTime/index';
import NewReservation from './layouts/newReservation';
import Requests from './layouts/requests';
import ReservationDays from './layouts/reservationDays/ReservationDays';
import ReservationNotebook from "./layouts/reservationNotebook";
import ReservationTimeSpan from './layouts/reservationTimeSpan/ReservationTimeSpan';
import Settings from "./layouts/settings";
import Site from "./layouts/site";
import UserAccess from "./layouts/userAccess";
import ClinicAnalytics from "layouts/analysis";

const routes = [
  {
    type: "collapse",
    name: "داشبورد",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    role: ["center"],
    component: <Dashboard />
  },
  {
    type: "collapse",
    name: "لیست نوبت ها",
    key: "reservationList",
    icon: <Icon fontSize="small">format_list_bulleted</Icon>,
    role: ["center", "reservation", "notebookReservation"],
    route: "/reservationList",
    component: <ReservedList />
  },
  {
    type: "collapse",
    name: "وضعیت نوبت ها",
    key: "reservationStatus",
    icon: <Icon fontSize="small">list_alt</Icon>,
    role: ["center", "reservation"],
    route: "/reservationStatus",
    component: <ReservationStatus />
  },
  {
    type: "collapse",
    name: "آنالیز",
    key: "analysis",
    icon: <Icon fontSize="small">list_alt</Icon>,
    role: ["center"],
    route: "/analysis",
    component: <ClinicAnalytics />
  },
  {
    type: "collapse",
    name: "دفتر نوبت دهی",
    key: "reservationNotebook",
    icon: <Icon fontSize="small">import_contacts</Icon>,
    role: ["center", "reservation", "notebookReservation"],
    route: "/reservationNotebook",
    component: <ReservationNotebook />
  },
  {
    type: "collapse",
    name: "تایید صندوق",
    key: "admission",
    role: ["center", "reception"],
    icon: <Icon fontSize="small">how_to_reg</Icon>,
    route: "/admission",
    component: <Admission />
  },
  {
    type: "collapse",
    name: "ثبت نوبت جدید",
    key: "new-reservation",
    icon: <Icon fontSize="small">add</Icon>,
    role: ["center", "reservation"],
    route: "/new-reservation",
    component: <NewReservation />
  },
  {
    type: "collapse",
    name: "گروه و درخواست ها",
    key: "requests",
    icon: <Icon fontSize="small">assignment</Icon>,
    role: ["center", "reservation"],
    route: "/requests",
    component: <Requests />,
  },
  {
    type: "collapse",
    name: "ثبت بازه زمانی",
    key: "scenario-timeSpan",
    icon: <Icon fontSize="small">more_time</Icon>,
    role: ["center", "reservation"],
    route: "/scenario-timeSpan",
    component: <ReservationTimeSpan />,
  },
  {
    type: "collapse",
    name: "ثبت روز های نوبت دهی",
    key: "reservation-days",
    icon: <Icon fontSize="small">date_range</Icon>,
    role: ["center", "reservation"],
    route: "/reservation-days",
    component: <ReservationDays />,
  },
  {
    type: "collapse",
    name: "پرکردن تایم",
    key: "fill-time",
    icon: <Icon fontSize="small">schedule</Icon>,
    role: ["center", "reservation"],
    route: "/fill-time",
    component: <FillTime />,
  },
  {
    type: "collapse",
    name: "بیمه ها",
    key: "insurance",
    icon: <Icon fontSize="small">insert_drive_file</Icon>,
    role: ["center"],
    route: "/insurance",
    component: <Insurance />,
  },
  {
    type: "collapse",
    name: "تنظیمات نوبت دهی",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    role: ["center"],
    route: "/settings",
    component: <Settings />,
  },
  {
    type: "collapse",
    name: "دسترسی کاربران",
    key: "userAccess",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/userAccess",
    role: ["superadmin","center"],
    component: <UserAccess />,
  },
  {
    type: "collapse",
    name: "اطلاعات سایت",
    key: "site-info",
    role: ["center"],
    icon: <Icon fontSize="small">info</Icon>,
    route: "/site-info",
    component: <Site />,
  },
];

export default routes;
